import { computed } from 'vue';
import useExperimentIds from '@composables/useExperimentIds';
import usePageType from '@modules/discovery/composables/usePageType';

const ONE_CLICK_SALE_EXP_ID = '2644-21';

export default function useOneClickSaleFilterExp() {
  const { experimentIds } = useExperimentIds();
  const { isSearch } = usePageType();

  const oneClickSaleExpEnabled = computed(() => experimentIds.value.includes(ONE_CLICK_SALE_EXP_ID) && isSearch);

  return {
    oneClickSaleExpEnabled,
  };
}
